module.exports = __webpack_public_path__ + "static/staff-john-10-dbd09f0123b9781f93bfc3acc1c29b10.png";